import ApiCompanyDescription from 'types/api/CompanyDescription';

import Model from 'models/Model';

export enum Types {
    About = 'about',
    History = 'history',
}

export default class CompanyDescription implements Model {
    id: string;
    description: {
        id: string;
        type: Types;
        order: number;
        title: string;
        description: string;
    };

    constructor(data: ApiCompanyDescription) {
        this.id = data.id;
        this.description = data.description;
    }
}